"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProposedDelivery = void 0;
var index_1 = require("./index");
var buildUpdateActions_1 = require("./lib/buildUpdateActions");
var isDefined_1 = require("./utils/isDefined");
var money_1 = __importDefault(require("./utils/money"));
var subscription_1 = require("./utils/subscription");
var flatMap_1 = __importDefault(require("lodash/flatMap"));
var ProposedDelivery = /** @class */ (function () {
    function ProposedDelivery(client, subscriptions, groupByInterval) {
        if (groupByInterval === void 0) { groupByInterval = true; }
        this.client = client;
        this.subscriptions = subscriptions;
        this.paymentMethod = client.paymentMethod;
        if (!subscriptions[0].nextShipOn) {
            throw new Error('a nextShipOn is required');
        }
        this.groupedSubscriptions = (0, subscription_1.groupSubscriptionsByParent)(subscriptions);
        this.shipOn = subscriptions[0].nextShipOn;
        this.shippingAddress = subscriptions[0].shippingAddress;
        this.shippingAddressId = subscriptions[0].shippingAddressId;
        var availableSubscriptions = this.groupedSubscriptions
            .filter(function (s) { return !s.unavailableReason || s.displayBackupProduct; })
            .map(function (s) { return (0, subscription_1.subscriptionOrBackup)(s); });
        var beforeDiscount = money_1.default.sumBy(availableSubscriptions, function (s) { return s.extendedPrice; });
        var afterDiscount = money_1.default.sumBy(availableSubscriptions, function (s) { return s.discountedExtendedPrice; });
        var discount = money_1.default.subtract(beforeDiscount, afterDiscount);
        this.totals = {
            discount: money_1.default.dollars(discount) > 0 ? discount : undefined,
            subtotal: afterDiscount,
        };
        var intervals = subscriptions.map(function (s) { return s.interval; }).filter(isDefined_1.isDefined);
        this.interval = intervals.length > 0 ? Math.min.apply(Math, intervals) : undefined;
        var id = "".concat(this.shipOn.replace(/-/g, '')).concat(this.shippingAddressId);
        this.id = this.interval && groupByInterval ? "".concat(this.interval).concat(id) : id;
    }
    /** @deprecated since 0.3.9; use .paymentMethod property */
    ProposedDelivery.prototype.getPaymentMethod = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.paymentMethod];
            });
        });
    };
    ProposedDelivery.prototype.sendNow = function () {
        return __awaiter(this, void 0, void 0, function () {
            var callback;
            return __generator(this, function (_a) {
                callback = function (sub) {
                    // FIXME once same-day fulfillment is wired, change this to today
                    var tomorrow = new Date().setUTCHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000;
                    // FIXME change this to check with webstore about nextShip
                    var nextShipOnCalculated = new Date(tomorrow)
                        .toISOString()
                        .substring(0, '0000-00-00'.length);
                    var nextNextShipOnCalculated = index_1.Subscription.calculateNextShipOn({
                        interval: sub.interval,
                        nextShipOn: nextShipOnCalculated,
                    });
                    return {
                        nextNextShipOn: nextNextShipOnCalculated,
                        nextShipOn: nextShipOnCalculated,
                    };
                };
                return [2 /*return*/, this.update(callback)];
            });
        });
    };
    /** @deprecated since 0.3.8; use .shippingAddress property */
    ProposedDelivery.prototype.getShippingAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.shippingAddress];
            });
        });
    };
    ProposedDelivery.prototype.skip = function () {
        return __awaiter(this, void 0, void 0, function () {
            var callback, proposedDeliveries, earliestDelivery, reassignmentCallback;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        callback = function (sub) {
                            if (sub.interval) {
                                var nextShipOnCalculated = index_1.Subscription.calculateNextShipOn(sub);
                                var nextNextShipOnCalculated = index_1.Subscription.calculateNextShipOn({
                                    interval: sub.interval,
                                    nextShipOn: nextShipOnCalculated,
                                });
                                return {
                                    nextNextShipOn: nextNextShipOnCalculated,
                                    nextShipOn: nextShipOnCalculated,
                                };
                            }
                            return {};
                        };
                        return [4 /*yield*/, this.update(callback)];
                    case 1:
                        proposedDeliveries = _a.sent();
                        earliestDelivery = proposedDeliveries.find(function (d) {
                            return d.shipOn !== _this.shipOn &&
                                d.shippingAddressId === _this.shippingAddressId;
                        });
                        reassignmentCallback = function (sub) {
                            if (!!sub.interval) {
                                return {};
                            }
                            if (!earliestDelivery) {
                                return {
                                    active: false,
                                    cancellationReason: {
                                        en: 'Unable to find proposedDelivery with matching address or set `shipOn` value',
                                    },
                                    cancelledAt: new Date().toISOString(),
                                    nextShipOn: undefined,
                                    nextNextShipOn: undefined,
                                };
                            }
                            return { nextShipOn: earliestDelivery.shipOn };
                        };
                        return [2 /*return*/, this.update(reassignmentCallback)];
                }
            });
        });
    };
    ProposedDelivery.prototype.update = function (changesOrCallback) {
        return __awaiter(this, void 0, void 0, function () {
            var callback, mySubscriptionIds, subscriptions;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        callback = typeof changesOrCallback === 'function'
                            ? changesOrCallback
                            : function () { return changesOrCallback; };
                        mySubscriptionIds = this.subscriptions.map(function (s) { return s.id; });
                        subscriptions = this.subscriptions;
                        return [4 /*yield*/, (0, index_1.retry)(function () { return __awaiter(_this, void 0, void 0, function () {
                                var actions;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            actions = (0, flatMap_1.default)(subscriptions, function (sub) {
                                                var changes = callback(sub);
                                                var normalized = sub.normalize(changes);
                                                return (0, buildUpdateActions_1.buildUpdateActions)(normalized, sub);
                                            });
                                            return [4 /*yield*/, this.client.updateLineItems(actions)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, {
                                onError: function (e) { return e.statusCode === 409; },
                                reset: function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, this.client.getSubscriptions({
                                                    force: true,
                                                    includeInactive: true,
                                                    preloadImagesAndPaths: false,
                                                    preloadPaymentMethod: false,
                                                    preloadShippingAddresses: false,
                                                })];
                                            case 1:
                                                subscriptions = (_a.sent()).filter(function (s) { return mySubscriptionIds.includes(s.id); });
                                                return [2 /*return*/];
                                        }
                                    });
                                }); },
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.client.getNextDeliveries()];
                }
            });
        });
    };
    return ProposedDelivery;
}());
exports.ProposedDelivery = ProposedDelivery;
//# sourceMappingURL=ProposedDelivery.js.map